module.exports = new __parcel__URL__("bossfight_tweet_this_button.7ee3d66f.png").toString();